document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.c-logo-slider');
  
  if (!sliders.length) return;

  function ensureFill(slider) {
    const container = slider.querySelector('.c-logo-slider__container');
    const inner = slider.querySelector('.c-logo-slider__inner');
    if (!inner) return;

    const items = Array.from(inner.querySelectorAll('.c-logo-slider__item'));
    if (!items.length) return;

    if (!inner.dataset.originalCount) {
      inner.dataset.originalCount = String(items.length);
    }
    const originalCount = Number(inner.dataset.originalCount) || items.length;

    const targetWidth = (container ? container.offsetWidth : slider.offsetWidth) * 2;
    let guard = 0;

    while (inner.scrollWidth < targetWidth && guard < 20) {
      for (let i = 0; i < originalCount; i++) {
        const clone = items[i].cloneNode(true);
        inner.appendChild(clone);
      }
      guard += 1;
    }
  }

  function init(slider) {
    ensureFill(slider);
  }

  sliders.forEach(init);

  window.addEventListener('load', function () {
    sliders.forEach((slider) => {
      ensureFill(slider);
    });
  }, { once: true });
});

